/**
 * Install function to register a component
 */
export default function (Vue) {
  Vue.component(this.name, this)
}



// WEBPACK FOOTER //
// ./src/packages/utils/install.js